import { gql } from "graphql-tag";

export const createPromptAnswer = gql`
  mutation CreatePromptAnswer($promptId: Int!, $bookId: Int!) {
    insertResult: insert_prompt_answer(
      object: { prompt_id: $promptId, book_id: $bookId }
    ) {
      promptAnswer: prompt_answer {
        ...PromptAnswerFragment
        promptBook: prompt_book {
          promptId: prompt_id
          bookId: book_id
          answersCount: answers_count
        }
        prompt {
          id
          slug
        }
      }
    }
  }
`;

export interface CreatePromptAnswerType {
  insertResult: {
    promptAnswer: {
      id: number;
      promptBook: {
        promptId: number;
        bookId: number;
        answersCount: number;
      };
      prompt: {
        id: number;
        slug: string;
      };
    };
  }
}